import React from 'react';
import { Form } from 'formik';
import GenericParentQuestion from './genericParentQuestion';
// @ts-ignore
import { Button, Loader } from 'arag-ui-lib';
import {
    ObjectOfAny,
    ObjectOfStrings,
    QuestionSchema,
} from '../../reducers/types';
import GenericChildQuestions from './genericChildQuestions';
import FormikQuestion from '../formikQuestion/formikQuestion';
import { CurrencySchema } from '../../actions';
import i18n from '../../i18n/i18n';

type ChildQuestionsProps = RemoveUnnecessaryAnswersProps & {
    questionTypes: ObjectOfAny;
    loading?: boolean;
    onAutoSaveDraftClaim?: (values: any) => void;
};
type RemoveUnnecessaryAnswersProps = {
    question: QuestionSchema;
    questions: QuestionSchema[];
    currency?: ObjectOfStrings | undefined;
    currencyOptions?: CurrencySchema[] | null;
    handleCurrencySelectWrapper?: (
        currency: ObjectOfStrings | undefined,
        values?: any,
    ) => void;
    notUseFieldValidator?: boolean;
    defaultLabelSize?: string;
    defaultInputSize?: string;
    hasDynamicStyle?: boolean;
    dynamicStyle?: string;
};
const GenericFormWithChildQuestions = (props: Props): JSX.Element | null => {
    return (
        <Form
            className="form-horizontal"
            autoComplete="off"
            autoCorrect="off"
            spellCheck="false"
        >
            {props.children}
        </Form>
    );
};

GenericFormWithChildQuestions.Body = (props: Props): JSX.Element => {
    return <>{props.children}</>;
};

GenericFormWithChildQuestions.ParentElement = (props: Props): JSX.Element => {
    return (
        <>
            <GenericParentQuestion>{props.children}</GenericParentQuestion>
        </>
    );
};

GenericFormWithChildQuestions.ChildrenElement = (
    props: ChildQuestionsProps,
): JSX.Element => {
    const {
        question,
        questions,
        questionTypes,
        notUseFieldValidator,
        handleCurrencySelectWrapper,
        currency,
        currencyOptions,
        defaultLabelSize,
        defaultInputSize,
        hasDynamicStyle,
        dynamicStyle,
        loading,
        onAutoSaveDraftClaim,
    } = props;
    return (
        <div className={hasDynamicStyle ? dynamicStyle : ''}>
            <GenericChildQuestions question={question} questions={questions}>
                <FormikQuestion
                    key={question.id}
                    question={question}
                    questionTypes={questionTypes}
                    labelSize={
                        defaultLabelSize
                            ? defaultLabelSize
                            : question.groupShape
                              ? 'col-sm-6 col-sm-offset-0'
                              : 'col-sm-3'
                    }
                    inputSize={
                        defaultInputSize
                            ? defaultInputSize
                            : question.groupShape
                              ? 'col-sm-1 col-sm-offset-3'
                              : 'col-sm-7'
                    }
                    infoText={question.tooltip}
                    handleCurrencySelectWrapper={handleCurrencySelectWrapper}
                    currency={currency}
                    currencyOptions={currencyOptions}
                    onAutoSaveDraftClaim={onAutoSaveDraftClaim}
                />
            </GenericChildQuestions>
        </div>
    );
};

GenericFormWithChildQuestions.SubmitForm = (props: Props): JSX.Element => {
    return <div>{props.children}</div>;
};

GenericFormWithChildQuestions.SubmitButton = (props: {
    defaultInputSize: string;
    initialValues: any;
    disabledSubmitButton: boolean;
    hideSubmitButton: boolean;
}): JSX.Element => {
    const { defaultInputSize, initialValues, disabledSubmitButton } = props;
    return (
        <>
            <div className={`${!defaultInputSize ? 'row' : 'container'}`}>
                <div className={`${!defaultInputSize ? 'row col-sm-12' : ''}`}>
                    <div
                        className={`${!defaultInputSize ? 'row col-sm-3 col-sm-offset-3 ' : 'row col-sm-1'}`}
                    >
                        <Button
                            variant={'primary'}
                            label={
                                initialValues &&
                                Object.values(initialValues).length > 0
                                    ? i18n.t('update')
                                    : i18n.t('save')
                            }
                            type={'submit'}
                            disabled={disabledSubmitButton}
                            arrowDirection={'right'}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

GenericFormWithChildQuestions.Loading = (props: {
    loading: boolean;
}): JSX.Element => {
    const { loading } = props;
    return (
        <>{loading && <Loader variant="inline" label={i18n.t('updating')} />}</>
    );
};

type Props = {
    children: React.ReactNode | JSX.Element | JSX.Element[] | any;
};

export default GenericFormWithChildQuestions;
